import { createAsyncThunk } from '@reduxjs/toolkit';
import { LOADING_STATUS } from '../../../shared/constants/loadingStatus';
import { fetchCampaigns } from '../../templates/api/templatesMetaApi';
import {
  fetchCampaignCadence,
  fetchCampaignCadenceTriggers,
  patchCampaignCadenceOrder,
} from '../api/campaignCadencesApi';
import { CAMPAIGN_CADENCES_TYPE_TAB_KEY } from '../constants/campaignCadencesTabs';
import { resolveChannelsForTab } from '../../templates/store/lib/resolveChannelsForTab';
import { getCampaignCadenceKey } from '../lib/getCampaignCadenceKey';
import {
  campaignCadencesCampaignsFailed,
  campaignCadencesCampaignsReceived,
  campaignCadencesCampaignsRequested,
  campaignCadencesFailed,
  campaignCadencesReceived,
  campaignCadencesRequested,
  campaignCadencesReorderFailed,
  campaignCadencesReorderRequested,
  campaignCadencesReorderSucceeded,
} from './campaignCadencesSlice';

async function fetchCampaignCadenceContent({ typeTab, campaignId, channel }) {
  if (typeTab === CAMPAIGN_CADENCES_TYPE_TAB_KEY.TRIGGERS) {
    const channels = resolveChannelsForTab({ tabKey: channel });
    const templates = await fetchCampaignCadenceTriggers({ channels });
    const items = (Array.isArray(templates) ? templates : []).map((template) => ({
      id: template.id,
      template,
    }));
    return { id: null, items };
  }
  return fetchCampaignCadence({ campaignId, channel });
}

export const loadCampaignCadenceCampaigns = createAsyncThunk(
  'campaignCadences/loadCampaigns',
  async (_, { dispatch, rejectWithValue }) => {
    dispatch(campaignCadencesCampaignsRequested());
    try {
      const data = await fetchCampaigns();
      dispatch(campaignCadencesCampaignsReceived(data));
      return data;
    } catch (error) {
      dispatch(campaignCadencesCampaignsFailed());
      return rejectWithValue(error?.message);
    }
  },
);

export const loadCampaignCadenceContent = createAsyncThunk(
  'campaignCadences/loadContent',
  async ({ typeTab, campaignId, channel }, { dispatch, getState, rejectWithValue }) => {
    const key = getCampaignCadenceKey({ typeTab, campaignId, channel });
    const existingStatus = getState().campaignCadences.campaignCadenceStatuses[key];

    if (existingStatus === LOADING_STATUS.SUCCEEDED || existingStatus === LOADING_STATUS.LOADING) {
      return;
    }

    dispatch(campaignCadencesRequested(key));
    try {
      const data = await fetchCampaignCadenceContent({ typeTab, campaignId, channel });
      dispatch(campaignCadencesReceived({ key, data }));
      return data;
    } catch (error) {
      dispatch(campaignCadencesFailed({ key, error: error?.message }));
      return rejectWithValue(error?.message);
    }
  },
);

export const reorderCampaignCadence = createAsyncThunk(
  'campaignCadences/reorder',
  async ({ campaignCadenceId, steps }, { dispatch, rejectWithValue }) => {
    dispatch(campaignCadencesReorderRequested());
    try {
      const data = await patchCampaignCadenceOrder({ campaignCadenceId, steps });
      dispatch(campaignCadencesReorderSucceeded(data));
      return data;
    } catch (error) {
      dispatch(campaignCadencesReorderFailed(error?.message));
      return rejectWithValue(error?.message);
    }
  },
);
